module.exports = __webpack_public_path__ + "img/no-order.f0f1a98e.png";